module.exports = __webpack_public_path__ + "img/information_inspiring_design_mob@2x.b18c0a3.jpg";